import React, { memo, useCallback } from 'react'

import DataFiltering from 'components/CommonUI/DataFiltering/DataFiltering'
import Picker from 'components/CommonUI/Datepicker/Datepicker'

const DateRangeFilter = ({
  selectedDateRange,
  handleChange,
  className = '',
}) => {
  const handleChangeDateRange = useCallback(
    (values) => {
      handleChange({
        id: values?.id || null,
        label: values?.label || null,
        value: {
          ...values.value,
        },
      })
    },
    [handleChange]
  )

  const valueForPicker = selectedDateRange?.id
    ? { start_timestmp: null, end_timestmp: null }
    : { ...selectedDateRange.value }

  return (
    <div className={`date_range_filter_container ${className}`}>
      <DataFiltering
        handleChange={handleChangeDateRange}
        selectedDate={selectedDateRange}
      />
      <span className="separator">or</span>
      <Picker
        handleSetDateRange={handleChangeDateRange}
        values={valueForPicker}
      />
    </div>
  )
}

export default memo(DateRangeFilter)
